export default __webpack_public_path__ + "static/media/music2.f70ee6e8.jpg";